module.exports = __webpack_public_path__ + "img/pauseImage.3dfb7e69.png";